export default __webpack_public_path__ + "static/media/logo-pnh - Copy.2e080508.png";